import gql from 'graphql-tag';
import { answerFieldsFragment } from './answerFieldsFragment';
import { evaluationFieldsFragment } from './evaluationFieldsFragment';
import { questionFieldsFragment } from './questionFieldsFragment';

export const scheduledSessionParticipantEntryAnswerFieldsFragment = gql`
  fragment AdminScheduledSessionParticipantEntryAnswerFields on ScheduledSessionParticipantEntryAnswer {
    evaluation { _ref }
    question { _ref }
    comment
    answers { ...AdminAnswerFields }
  }

  ${answerFieldsFragment}
  ${questionFieldsFragment}
  ${evaluationFieldsFragment}
`;